/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./avatar-DXnMbTHM.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/employee-cell/employee-cell.css.js
var l = r(":host{display:block}.avatar{font-size:.75em}.wrapper{align-items:center;gap:.5em;min-width:0;display:flex}.content{flex:1;align-items:baseline;gap:.3em;min-width:0;display:flex}.name{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.staff-number{opacity:.6;font-size:.85em}"), u = class extends e(i) {
	constructor(...e) {
		super(...e), this.positionColors = [], this.showStaffNumber = !1, this.nameFormat = "firstLast", this.styles = l;
	}
	_formatName() {
		if (!this.employee) return "";
		let { firstName: e, lastName: t } = this.employee;
		return this.nameFormat === "lastFirst" ? `${t}, ${e}` : `${e} ${t}`;
	}
	render() {
		return a`
            <div class="wrapper">
                <ptc-ui-avatar
                    class="avatar"
                    .employee=${this.employee}
                    .positionColors=${this.positionColors}
                ></ptc-ui-avatar>
                <div class="content">
                    <span class="name">${this._formatName()}</span>
                    ${this.showStaffNumber && this.employee?.staffNumber ? a`<span class="staff-number">#${this.employee.staffNumber}</span>` : o}
                </div>
                <slot name="trailing"></slot>
            </div>
        `;
	}
};
n([c({ attribute: !1 }), t("design:type", Object)], u.prototype, "employee", void 0), n([c({ type: Array }), t("design:type", Array)], u.prototype, "positionColors", void 0), n([c({ type: Boolean }), t("design:type", Object)], u.prototype, "showStaffNumber", void 0), n([c({ type: String }), t("design:type", String)], u.prototype, "nameFormat", void 0), u = n([s("ptc-ui-employee-cell")], u);
var d = u;
//#endregion
export { d as n, u as t };

//# sourceMappingURL=employee-cell-BmK1kBUm.js.map